import Loading from '../../../../Dashboards/Common/Loading';
import { FetalDeaths } from './FetalDeaths';
import { Indicators } from './Indicators';
import { LiveBirthsWithAnomaly } from './LiveBirthsWithAnomaly';
import { MothersLessThan6PrenatalConsultations } from './MothersLessThan6PrenatalConsultations';
import { PopulationBalance } from './PopulationBalance';
import { TenagerMothers } from './TenagerMothers';
import { VitalStatisticsComparison } from './VitalStatisticsComparison';
import { WeightIndex } from './WeightIndex';
import { useGeneralResultsChartsDataContext } from './hooks/useGeneralResultsChartsDataContext';
import './styles/Charts.css';

export const Charts = () => {
    const { isLoading } = useGeneralResultsChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="chats-indicators-side-by-side-dashboards">
                <FetalDeaths />
                <LiveBirthsWithAnomaly />
                <MothersLessThan6PrenatalConsultations />
                <WeightIndex />
                <TenagerMothers />
            </div>
            <div className="side-by-side-group">
                <Indicators />
                <div className="right-group">
                    <VitalStatisticsComparison />
                    <PopulationBalance />
                </div>
            </div>
        </>
    );
};
